<div class="project-tasks">
    <app-project-library-items [projectDetails]="projectDetails" [libraryType]="libraryType" (projectDetailsChanged)="taskDetailsChanged($event)"></app-project-library-items>
</div>
